module.exports = __webpack_public_path__ + "static/media/porsche-go-drive.f4951463.png";